<template>
  <formulaire-view :steps="steps" :step="step" url="/demande-modification-societe/" paramsName="modification_societe" :endpoint="endpoint" :getRefs="$refs">
    <template v-slot:step="{ sas, path, setState, code }">
      <component :is="path" :sas="sas" @validation-changed="setState(path, $event)" :ref="path" :endpoint="endpoint">
        <ressource :code="code" />
      </component>
    </template>
  </formulaire-view>
</template>

<script>

import FormulaireView from "@/views/FormulaireView.vue"

import Societe from "@/components/Formulaires/DemandeModificationSociete/Societe.vue"
import Actionnaire from "@/components/Formulaires/DemandeModificationSociete/Actionnaire.vue"
import Dissociation from "@/components/Formulaires/DemandeModificationSociete/Dissociation.vue"
import Repondant from "@/components/Formulaires/DemandeModificationSociete/Repondant.vue"
import Ouverture from "@/components/Formulaires/DemandeModificationSociete/Ouverture.vue"
import Fermeture from "@/components/Formulaires/DemandeModificationSociete/Fermeture.vue"
import Achat from "@/components/Formulaires/DemandeModificationSociete/Achat.vue"
import Vente from "@/components/Formulaires/DemandeModificationSociete/Vente.vue"
import Demenagement from "@/components/Formulaires/DemandeModificationSociete/Demenagement.vue"
import Cessation from "@/components/Formulaires/DemandeModificationSociete/Cessation.vue"
import Declaration from "@/components/Formulaires/DemandeModificationSociete/Declaration.vue"

export default {
  props: {
    step: String
  },
  data() {
    return {
      endpoint: "demande-modification-societe",
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "societe", code: "titre-etape-1", state: "" },
        { path: "actionnaire", code: "titre-etape-2", state: "" },
        { path: "dissociation", code: "titre-etape-3", state: "" },
        { path: "Repondant", code: "titre-etape-4", state: "" },
        { path: "ouverture", code: "titre-etape-5", state: "" },
        { path: "fermeture", code: "titre-etape-6", state: "" },
        { path: "achat", code: "titre-etape-7", state: "" },
        { path: "vente", code: "titre-etape-8", state: "" },
        { path: "demenagement", code: "titre-etape-9", state: "" },
        { path: "cessation", code: "titre-etape-10", state: "" },
        { path: "declaration", code: "titre-etape-11", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    FormulaireView,
    Societe,
    Actionnaire,
    Dissociation,
    Repondant,
    Ouverture,
    Fermeture,
    Achat,
    Vente,
    Demenagement,
    Cessation,
    Declaration
  }
}
</script>